export default __webpack_public_path__ + "static/media/connected1.4539b95d.svg";